import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import { Button, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { makeStyles } from 'tss-react/mui';
import { teceoBlueBackground, teceoGreen } from '../../Theme';
import useTeceoStyles from '../../useTeceoStyles';

const useStyles = makeStyles()((theme) => ({
  radius: {
    borderRadius: theme.spacing(2),
  },
  dialogContent: {
    padding: theme.spacing(2),
    overflowY: 'hidden',
  },
  storeCard: {
    backgroundColor: teceoBlueBackground,
    color: 'white',
    '&:hover': {
      backgroundColor: teceoBlueBackground,
    },
  },
  brandCard: {
    backgroundColor: teceoGreen,
    color: 'white',
    '&:hover': {
      backgroundColor: teceoGreen,
    },
  },
}));

type CreateAccountModalProps = {
  open: boolean;
  onClose: () => void;
  onClickCreateStore: () => void;
};

const CreateAccountModal = ({ open, onClose, onClickCreateStore }: CreateAccountModalProps) => {
  const { classes, cx } = useStyles();
  const { classes: teceoClasses } = useTeceoStyles();
  return (
    <Dialog classes={{ paper: classes.radius }} maxWidth="xs" open={open} onClose={onClose}>
      <DialogContent className={classes.dialogContent}>
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid size={5}>
            <TeceoLogo />
          </Grid>
          <Grid size={12}>
            <Typography align="center" variant="h4">
              seja bem-vindo à teceo!
            </Typography>
            <Typography align="center" color="textSecondary" variant="body2">
              para começar, selecione uma das opções abaixo
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <Button
              fullWidth
              size="large"
              onClick={onClickCreateStore}
              className={cx(classes.storeCard)}
            >
              cadastrar minha loja
            </Button>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <a
              href="https://www.teceo.co/cadastrar-marca"
              target="_blank"
              className={teceoClasses.link}
              rel="noreferrer"
            >
              <Button fullWidth size="large" className={cx(classes.brandCard)}>
                cadastrar minha marca
              </Button>
            </a>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CreateAccountModal;
